import React from 'react';

export function LazyLoader() {
    return (
        <div className="w-[12px] h-[12px] rounded-full block mx-auto my-[15px] relative box-border bg-[#f12b2b] lazy-loader" />
    );
}
